import manufacturing from "../assets/manufacturing-icon.jpg";
import ecommerce from "../assets/ecommerce-icon.jpg";
import logistics from "../assets/logistics-icon.jpg";
import saas from "../assets/saas-icon.svg.jpg";
import comma1 from "../assets/inverted-commas-1.svg";
import comma2 from "../assets/inverted-commas-2.svg";
import active from "../assets/active.svg";

const industries = [
    { image: manufacturing, title: "Manufacturing" },
    { image: ecommerce, title: "E-Commerce" },
    { image: logistics, title: "Trade & Logistics" },
    { image: saas, title: "Services & SaaS" },
];

const Industries = () => {
    return (
        <>
            <div className="industries-container">
                <m>Diverse Sectors</m>
                <h1>Industries We Support</h1>
                <div className="industries-grid">
                    {industries.map((industry, index) => (
                        <div key={index} className="industry-card">
                            <img src={industry.image} alt={industry.title} />
                            <p>{industry.title}</p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="success-stories">
                <m>Proven Growth</m>
                <h1>Success Stories</h1>
                <div className="testimonial-container">
                    <div className="testimonial-box">
                        <div className="quote">
                            <img className="quote-start" src={comma1} alt="opening quote" />
                            <p>
                                Discreet, fast, and so easy to use! The at-home sample collection kit
                                gave me peace of mind without the stress of visiting a clinic. I
                                felt completely in control of my sexual health, and the process was
                                smooth from start to finish. Highly recommend!
                            </p>
                        </div>
                        <p className="author">— Alex R., Customer <img className="quote-end" src={comma2} alt="closing quote" /></p>
                    </div>
                    <img className="active-icon" src={active} alt="active-icon" />
                </div>
            </div>
        </>
    );
};

export default Industries;